import classNames from "classnames";
import "./index.scss";

interface IProps {
  label: string;
  backgroundColor?:
    | "red-none"
    | "gray"
    | "yellow"
    | "pale-green"
    | "green"
    | "red"
    | "dark-gray"
    | "light-yellow";
  styles?: string;
  dynamicBackgroundColor?: any;
  dynamicTextColor?: any;
}

export const Label = ({
  backgroundColor,
  label,
  styles,
  dynamicBackgroundColor,
  dynamicTextColor,
}: IProps) => {
  return (
    <div
      className={classNames("label", `label-bg-${backgroundColor}`, {
        [`${styles}`]: styles,
      })}
      style={{ backgroundColor: `${dynamicBackgroundColor}`}}
    >
      <p className={classNames("label-inner-text")} style={{color: `${dynamicTextColor}`}}>
        {label ? label : "custom label"}
      </p>
    </div>
  );
};
